<template>
    <div class="container-fluid">
        <Breadcrumb title="PMTA Balancers" :button-show="buttonShow"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-if="loading">
                <Preloader v-bind:class="{preloader: loading}"></Preloader>
            </div>
            <div class="col-12" v-else>
                <div class="card">
                    <div class="card-body">
                        <div class="form-group">
                            <div class="form-group mb-2 float-right">
                                <button type="button" class="btn btn-primary btn-rounded"
                                        @click="uploadBalancerConfig">
                                    <i class="fas fa-sync"></i>
                                    Sync
                                </button>
                            </div>
                        </div>
                        <div v-if="balancers.length === 0">No PMTA Balancers</div>
                        <div v-else>
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Mail Service</th>
                                        <th>Sync</th>
                                        <th>Description</th>
                                        <th>Delete</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(balancer, index) in balancers" :key="index">
                                        <td>{{balancer.id}}</td>
                                        <td>{{balancer.balancerName}}</td>
                                        <td>
                                            <span class="badge badge-success"
                                                  v-if="balancer.status === balancerStatus.UPLOADED">
                                                {{balancerStatus.value[balancer.status]}}
                                            </span>
                                            <span class="badge badge-danger"
                                                  v-if="balancer.status === balancerStatus.UPLOAD_FAILED">
                                               {{balancerStatus.value[balancer.status]}}
                                            </span>
                                            <span class="badge badge-warning"
                                                  v-if="balancer.status === balancerStatus.REMOVED">
                                                {{balancerStatus.value[balancer.status]}}
                                            </span>
                                        </td>
                                        <td>{{balancer.comment}}</td>
                                        <td>
                                            <button @click="deleteBalancer(balancer.id)" class="btn btn-danger"
                                                    type="button" v-show="balancer.status !== balancerStatus.REMOVED">
                                                <i class="fa fa-minus-circle"></i> Delete
                                            </button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Breadcrumb from '../components/Breadcrumb';
    import Preloader from '../components/Preloader'
    import PmtaBalancerService from '../services/PmtaBalancerService';
    import Swal from 'sweetalert2'
    import {BalancerStatus} from '../constants';
    import paginateMixin from '../mixins/paginate-mixin';

    export default {
        name: 'PmtaServerBalancers',
        components: {
            Preloader, Breadcrumb
        },
        mixins: [ paginateMixin ],
        data() {
            return {
                loading: false,
                balancers: [],
                buttonShow: false,
                balancerStatus: BalancerStatus
            }
        },
        mounted() {
            this.loading = true;
            this.getBalancers(this.$route.params.id);
        },
        methods: {
            getBalancers(id) {
                PmtaBalancerService.getServerBalancers(id).then(response => {
                    this.balancers = response.data;
                    this.loading = false;
                });
            },
            async uploadBalancerConfig() {
                this.loading = true;
                let data = {
                    id: this.$route.params.id
                };
                await PmtaBalancerService.balancersConfigUpload(data).then(() => {
                    this.getBalancers(this.$route.params.id);
                    this.loading = false;
                });
            },
            deleteBalancer(id) {
                Swal({
                    title: 'Are you sure you want to delete?',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return PmtaBalancerService.deleteBalancer(id).then((response) => {
                            if (response.status === 200) {
                                this.getBalancers(this.$route.params.id);
                            }
                        }).catch(error => {
                            Swal.showValidationMessage(
                                `Request failed: ${error}`
                            )
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Deleted successfully!',
                            `Balancer has been deleted.`,
                            'success'
                        )
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>